/* MURO — comportements du thème Shopify : visuels, panier (API AJAX Shopify), filtres, quiz, fiche produit. */

const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const SHOP = window.MURO_SHOP || { root: '/', products: {} };
const shopUrl = path => (SHOP.root.endsWith('/') ? SHOP.root : SHOP.root + '/') + path;
const money = cents => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: SHOP.currency || 'EUR' }).replace(/[,.]00(?=\s|$)/, '');
const shopInfo = p => (p && SHOP.products[p.handle]) || null;
const priceOf = p => (shopInfo(p) ? money(shopInfo(p).price) : euro(p.price));
const urlOf = p => (shopInfo(p) ? shopInfo(p).url : shopUrl(`products/${p.handle}`));

/* ---------- Visuels et cartes ---------- */

// Les grilles suivent l'ordre du catalogue (Monceau → Marais → Bastille → Étoile → accessoires)
const catalogRank = handle => { const i = ALL_PRODUCTS.findIndex(p => p.handle === handle); return i < 0 ? 99 : i; };
function orderGrids(root = document) {
  $$('.grid-products', root).forEach(grid => {
    const cards = $$(':scope > [data-card]', grid);
    if (cards.length < 2) return;
    cards.sort((a, b) => catalogRank(a.dataset.handle) - catalogRank(b.dataset.handle)).forEach(c => grid.appendChild(c));
  });
}

function hydrate(root = document) {
  orderGrids(root);
  $$('[data-visual]', root).forEach(el => {
    const p = findByHandle(el.dataset.visual);
    if (!p) return;
    el.innerHTML = productVisual(p, { view: el.dataset.view || 'front' });
    const host = el.closest('[data-bg]');
    if (host) {
      host.style.setProperty('--bg', p.bg);
      host.style.color = p.dark ? '#F6F1E7' : '#111111';
    }
  });
  $$('[data-card]', root).forEach(card => {
    const p = findByHandle(card.dataset.handle);
    if (!p) return;
    const badge = $('[data-badge]', card);
    if (badge && p.badge) { badge.textContent = p.badge; badge.hidden = false; }
    const spec = $('[data-spec]', card);
    if (spec) spec.textContent = p.type === 'racket' ? p.motif : p.desc;
    const tags = $('[data-tags]', card);
    if (tags && p.type === 'racket') tags.innerHTML = `<span class="tag">${p.place} · ${p.num}</span><span class="tag">Carbone 12K</span>`;
  });
}

/* ---------- Toast ---------- */

let toastTimer;
function toast(msg) {
  const t = $('#toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('is-on');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('is-on'), 2800);
}

/* ---------- Panier (API AJAX Shopify) ---------- */

const cartApi = {
  async get() {
    const r = await fetch(shopUrl('cart.js'), { headers: { Accept: 'application/json' } });
    return r.json();
  },
  async post(path, body) {
    const r = await fetch(shopUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'Impossible d’ajouter au panier.');
    return data;
  },
  add(items) { return this.post('cart/add.js', { items }); },
  change(key, quantity) { return this.post('cart/change.js', { id: key, quantity }); }
};

function renderCart(cart) {
  $$('.cart-count').forEach(el => { el.textContent = cart.item_count; el.dataset.n = cart.item_count; });
  const drawer = $('.drawer');
  if (!drawer) return;

  const left = Math.max(0, SHOP.freeShipping - cart.total_price);
  const pct = SHOP.freeShipping ? Math.min(100, (cart.total_price / SHOP.freeShipping) * 100) : 100;
  $('#ship-msg').innerHTML = `${left > 0
    ? `Plus que <b>${money(left)}</b> pour la livraison offerte.`
    : '<b>Livraison offerte</b> · expédiée sous 24 h ouvrées.'}
    <div class="bar__track"><div style="width:${pct}%"></div></div>`;

  if (!cart.item_count) {
    $('#cart-items').innerHTML = `<div class="drawer__empty"><img src="${SHOP.assets}marcel.svg" alt=""><p>Marcel trouve ton panier bien vide.</p><a class="btn btn--sm" href="${shopUrl('collections/all')}">Voir les raquettes</a></div>`;
    $('#cart-foot').innerHTML = '';
    return;
  }

  $('#cart-items').innerHTML = cart.items.map(l => {
    const p = findByHandle(l.handle);
    const visual = p ? productVisual(p) : (l.image ? `<img src="${l.image}" alt="">` : '');
    const sub = p && p.type === 'racket' ? `${p.shape} · ${p.face}` : (l.variant_title || 'Accessoire');
    const name = l.product_title.split(' — ')[0];
    return `<div class="line">
      <a class="line__img" href="${l.url}" style="--bg:${p ? p.bg : '#ECE6DA'}">${visual}</a>
      <div>
        <div class="line__name">${name}</div>
        <div class="line__sub">${sub}</div>
        <div class="qty" aria-label="Quantité">
          <button data-line="${l.key}" data-q="${l.quantity - 1}" aria-label="Retirer un ${name}">−</button>
          <output>${l.quantity}</output>
          <button data-line="${l.key}" data-q="${l.quantity + 1}" aria-label="Ajouter un ${name}">+</button>
        </div>
      </div>
      <div class="line__right"><span class="price">${money(l.final_line_price)}</span><button class="link-btn" data-line="${l.key}" data-q="0">Retirer</button></div>
    </div>`;
  }).join('');

  $('#cart-foot').innerHTML = `
    <div class="drawer__total"><span>Sous-total</span><span class="price">${money(cart.total_price)}</span></div>
    <div class="muted" style="font-size:13px">TVA incluse · livraison calculée au paiement · échange 30 jours</div>
    <a class="btn btn--rouge btn--block" href="${shopUrl('checkout')}">Payer ${money(cart.total_price)} <span class="arrow">→</span></a>`;
}

const refreshCart = async () => renderCart(await cartApi.get());

function openCart() {
  document.documentElement.classList.add('is-cart-open');
  $('.drawer')?.setAttribute('aria-hidden', 'false');
}
function closeCart() {
  document.documentElement.classList.remove('is-cart-open');
  $('.drawer')?.setAttribute('aria-hidden', 'true');
}

async function addItems(items, btn) {
  if (btn) btn.disabled = true;
  try {
    await cartApi.add(items);
    await refreshCart();
    openCart();
  } catch (err) {
    toast(err.message);
  } finally {
    if (btn) btn.disabled = false;
  }
}

document.addEventListener('click', async e => {
  const t = e.target.closest('[data-open-cart],[data-close-cart],[data-line],[data-add-variant]');
  if (!t) return;
  if (t.matches('[data-open-cart]')) { e.preventDefault(); await refreshCart(); openCart(); }
  else if (t.matches('[data-close-cart]')) closeCart();
  else if (t.matches('[data-line]')) renderCart(await cartApi.change(t.dataset.line, Number(t.dataset.q)));
  else if (t.matches('[data-add-variant]')) addItems([{ id: Number(t.dataset.addVariant), quantity: 1 }], t);
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

/* ---------- Menu mobile ---------- */

function initMenu() {
  const burger = $('.burger');
  burger?.addEventListener('click', () => {
    const open = $('#nav').classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open);
  });
}

/* ---------- Collection : filtres et tri ---------- */

function initCollection() {
  const grid = $('[data-collection-grid]');
  if (!grid || !$('.chip[data-filter]')) return;
  const cards = $$('[data-card]', grid);
  const state = { play: null, level: null, shape: null, sort: 'reco' };
  const draw = () => {
    let shown = 0;
    cards.forEach(card => {
      const p = findByHandle(card.dataset.handle);
      const ok = !p || p.type !== 'racket' || (
        (!state.play || p.play.includes(state.play)) &&
        (!state.level || p.levels.includes(state.level)) &&
        (!state.shape || p.shapeKey === state.shape));
      card.hidden = !ok;
      if (ok) shown++;
    });
    const sorted = [...cards].sort((a, b) => state.sort === 'reco' ? catalogRank(a.dataset.handle) - catalogRank(b.dataset.handle)
      : (state.sort === 'asc' ? 1 : -1) * (Number(a.dataset.price) - Number(b.dataset.price)));
    sorted.forEach(c => grid.appendChild(c));
    $('#result-count').textContent = `${shown} raquette${shown > 1 ? 's' : ''}`;
    $('#collection-empty').hidden = shown > 0;
  };
  $$('.chip[data-filter]').forEach(chip => chip.addEventListener('click', () => {
    const { filter, value } = chip.dataset;
    state[filter] = state[filter] === value ? null : value;
    $$(`.chip[data-filter="${filter}"]`).forEach(c => c.setAttribute('aria-pressed', c.dataset.value === state[filter]));
    draw();
  }));
  $('#sort')?.addEventListener('change', e => { state.sort = e.target.value; draw(); });
  draw();
}

/* ---------- Fiche produit ---------- */

function initProduct() {
  const root = $('[data-product]');
  if (!root) return;
  const p = findByHandle(root.dataset.product);

  // vues face / détail / profil
  $$('[data-view-btn]', root).forEach(btn => btn.addEventListener('click', () => {
    $$('[data-view-btn]', root).forEach(b => b.setAttribute('aria-pressed', b === btn));
    const stage = $('[data-stage] [data-visual]', root);
    if (stage && p) { stage.dataset.view = btn.dataset.viewBtn; stage.innerHTML = productVisual(p, { view: btn.dataset.viewBtn }); }
  }));

  // compléments de fiche issus du catalogue
  const extras = $('[data-product-extras]', root);
  if (extras && p && p.type === 'racket') {
    $('[data-eyebrow]', root).textContent = `${p.badge} · ${p.place}, ${p.arr}ᵉ arr.`;
    extras.innerHTML = `
      <p class="pdp__tagline">${p.tagline}</p>
      <div class="marcel-says"><img src="${SHOP.assets}marcel.svg" alt=""><p><strong>L’avis de Marcel :</strong> ${p.vibe} C’est ton quartier.</p></div>`;
    $('[data-product-meta]', root).innerHTML = [p.shape, p.face, p.core, p.weight].map(t => `<span class="tag">${t}</span>`).join('');
    $('[data-product-stats]', root).innerHTML = Object.entries(p.stats).map(([k, v]) =>
      `<div class="stat"><span>${k}</span><div class="stat__track"><div class="stat__fill" data-w="${v}"></div></div><span class="stat__v">${v}</span></div>`).join('');
    requestAnimationFrame(() => $$('.stat__fill', root).forEach(el => { el.style.width = el.dataset.w + '%'; }));
    if (p.id === 'etoile') $('[data-stage]', root).insertAdjacentHTML('beforeend', '<div class="sticker"><span><b>300</b>ex. numérotés</span></div>');
  }

  // quantité + ajout (avec accessoires cochés)
  const form = $('form[data-product-form]', root);
  if (!form) return;
  const qtyInput = $('[name="quantity"]', form);
  const label = $('[data-add-label]', form);
  const unit = Number(form.dataset.price);
  const setQ = q => { qtyInput.value = Math.max(1, Math.min(9, q)); if (label) label.textContent = `Ajouter au panier · ${money(unit * qtyInput.value)}`; };
  $('[data-q-minus]', form)?.addEventListener('click', () => setQ(Number(qtyInput.value) - 1));
  $('[data-q-plus]', form)?.addEventListener('click', () => setQ(Number(qtyInput.value) + 1));
  form.addEventListener('submit', e => {
    e.preventDefault();
    const items = [{ id: Number($('[name="id"]', form).value), quantity: Number(qtyInput.value) }];
    $$('.addons input:checked', form).forEach(i => items.push({ id: Number(i.value), quantity: 1 }));
    addItems(items, $('[type="submit"]', form));
  });
}

function cardHTML(r) {
  const info = shopInfo(r);
  return `<article class="card" data-card data-handle="${r.handle}">
    <a class="card__media" href="${urlOf(r)}" style="--bg:${r.bg}" aria-label="Voir la ${r.name}">${racketSVG(r.id)}<span class="card__badge">${r.badge}</span></a>
    <div class="card__body">
      <div class="card__top"><h3 class="card__name"><a href="${urlOf(r)}">${r.name}</a></h3><span class="price">${priceOf(r)}</span></div>
      <p class="mono card__spec">${r.motif}</p>
      <div class="tags"><span class="tag">${r.place} · ${r.num}</span></div>
      <div class="card__foot">
        <a class="btn btn--sm btn--creme" href="${urlOf(r)}">Détails</a>
        ${info && info.available ? `<button class="btn btn--sm" type="button" data-add-variant="${info.variant}">Ajouter</button>` : ''}
      </div>
    </div>
  </article>`;
}

function initCompare() {
  const box = $('[data-compare]');
  if (!box) return;
  box.innerHTML = RACKETS.filter(r => r.handle !== box.dataset.compare).map(cardHTML).join('');
}

/* ---------- Quiz ---------- */

function initQuiz() {
  const box = $('#quiz');
  if (!box) return;
  const Q = [
    { k: 'after', t: 'Après le match, tu files…', o: [
      ['terrasse', 'En terrasse', 'Un verre au soleil, on refait le match.'],
      ['diner', 'Dîner chic', 'Nappe blanche et bon vin.'],
      ['nuit', 'Faire la fête', 'La soirée ne fait que commencer.']] },
    { k: 'jeu', t: 'Sur le terrain, tu es…', o: [
      ['stratege', 'Le stratège', 'Je place, je construis, je patiente.'],
      ['showman', 'Le showman', 'Je tente les coups impossibles.'],
      ['bulldozer', 'Le bulldozer', 'Je monte au filet et je smashe.']] },
    { k: 'style', t: 'Ta tenue de padel ?', o: [
      ['classique', 'Classique', 'Blanc, bleu marine, impeccable.'],
      ['couleur', 'Couleur', 'Plus c’est vif, mieux c’est.'],
      ['noir', 'Tout en noir', 'Sobre, efficace, mystérieux.']] },
    { k: 'envie', t: 'Ce qui compte le plus ?', o: [
      ['rare', 'Être le seul à l’avoir', 'Une série limitée, numérotée.'],
      ['style', 'Le style', 'Qu’on me remarque sur le terrain.'],
      ['plaisir', 'Le plaisir', 'Jouer, rire, recommencer.'],
      ['victoire', 'La victoire', 'Je joue pour gagner.']] }
  ];
  const W = {
    after: { terrasse: { marais: 3, 'saint-germain': 1 }, diner: { monceau: 3, opera: 1 }, nuit: { bastille: 2, etoile: 2 } },
    jeu: { stratege: { monceau: 2, 'saint-germain': 2 }, showman: { opera: 3, etoile: 1 }, bulldozer: { bastille: 3, marais: 1 } },
    style: { classique: { 'saint-germain': 3, monceau: 1 }, couleur: { marais: 2, opera: 2, bastille: 1 }, noir: { etoile: 3 } },
    envie: { rare: { etoile: 3 }, style: { 'saint-germain': 2, opera: 2 }, plaisir: { marais: 2, monceau: 1 }, victoire: { bastille: 3 } }
  };
  const answers = {};
  let step = 0;

  const show = () => {
    $('#quiz-bar').style.width = (step / Q.length) * 100 + '%';
    if (step >= Q.length) return result();
    const q = Q[step];
    box.innerHTML = `<div class="quiz__q">
      <span class="mono muted">Question ${step + 1} / ${Q.length}</span>
      <h2>${q.t}</h2>
      <div class="quiz__opts">${q.o.map(([v, t, s]) => `<button class="opt" type="button" data-v="${v}"><strong>${t}</strong><span>${s}</span></button>`).join('')}</div>
      ${step ? '<button class="quiz__back" type="button" id="back">← Question précédente</button>' : ''}
    </div>`;
    $$('.opt', box).forEach(b => b.addEventListener('click', () => { answers[q.k] = b.dataset.v; step++; show(); }));
    $('#back')?.addEventListener('click', () => { step--; show(); });
  };

  const result = () => {
    const score = { marais: 0.3, monceau: 0.25, bastille: 0.2, 'saint-germain': 0.15, opera: 0.1, etoile: 0 };
    Object.entries(answers).forEach(([k, v]) => Object.entries(W[k][v]).forEach(([m, pts]) => { score[m] += pts; }));
    const [first, second] = Object.entries(score).sort((a, b) => b[1] - a[1]).map(([m]) => findProduct(m));
    const info = shopInfo(first);
    box.innerHTML = `<div class="result">
      <div class="result__art" style="--bg:${first.bg}">${racketSVG(first.id)}</div>
      <div>
        <span class="eyebrow">Ton quartier · ${first.place}, ${first.arr}ᵉ</span>
        <h2>${first.name}</h2>
        <p class="pdp__tagline">${first.tagline}</p>
        <p>${first.vibe} ${first.desc[0]}</p>
        <ul>${first.forWho.map(f => `<li>${f}</li>`).join('')}</ul>
        <p class="muted">Même raquette pour tous : carbone 12K, EVA Medium, ${first.weight}.</p>
        <div class="hero__ctas">
          ${info && info.available ? `<button class="btn btn--rouge" type="button" data-add-variant="${info.variant}">Ajouter · ${priceOf(first)}</button>` : ''}
          <a class="btn btn--creme" href="${urlOf(first)}">Voir la fiche</a>
        </div>
        <p class="muted" style="margin-top:22px">Deuxième choix : <a href="${urlOf(second)}" style="text-decoration:underline">${second.name}</a> (${priceOf(second)}). <button class="link-btn" type="button" id="restart">Refaire le test</button></p>
      </div>
    </div>`;
    $('#restart').addEventListener('click', () => { step = 0; show(); });
  };
  show();
}

/* ---------- Démarrage ---------- */

initMenu();
hydrate();
initCollection();
initProduct();
initCompare();
initQuiz();
refreshCart().catch(() => {});
